module.exports = "/_next/static/images/3f8f9e687d2050841cd7b9c9a392db90-jorge_1@3x.png";